"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const content_change_watcher_1 = __importDefault(require("./content-change-watcher"));
const resize_observer_1 = __importDefault(require("./resize-observer"));
require("./style.css");
const utils_1 = require("./utils");
function ScrollBox(props) {
    var _a;
    const boxRef = react_1.useRef(null);
    const viewPortRef = react_1.useRef(null);
    const vTrackRef = react_1.useRef(null);
    const hTrackRef = react_1.useRef(null);
    const vThumbRef = react_1.useRef(null);
    const hThumbRef = react_1.useRef(null);
    const state = react_1.useRef({
        viewPortHeight: 0,
        viewPortWidth: 0,
        contentHeight: 0,
        contentWidth: 0,
        vRatio: 0,
        hRatio: 0,
        vTrackHeight: 0,
        hTrackWidth: 0,
        vThumbHeight: 0,
        hThumbWidth: 0,
        maxVThumbTop: 0,
        maxHThumbLeft: 0,
        startCursorY: 0,
        startCursorX: 0,
        startVThumbTop: 0,
        startHThumbLeft: 0,
        currentVThumbTop: 0,
        currentHThumbLeft: 0,
        ignoreScrollEvent: false,
    }).current;
    const reset = react_1.useCallback(() => {
        const viewPort = viewPortRef.current;
        const vTrack = vTrackRef.current;
        const hTrack = hTrackRef.current;
        const vThumb = vThumbRef.current;
        const hThumb = hThumbRef.current;
        utils_1.culcSize(viewPort, vTrack, hTrack, state);
        utils_1.resetScrollbar(vTrack, vThumb, hTrack, hThumb, state);
    }, [state]);
    const draggingVThumb = react_1.useCallback(utils_1.rafThrottle((e) => {
        const cursorMoveDistance = e.y - state.startCursorY;
        state.currentVThumbTop = state.startVThumbTop + cursorMoveDistance;
        if (state.currentVThumbTop < 0) {
            state.currentVThumbTop = 0;
        }
        if (state.currentVThumbTop > state.maxVThumbTop) {
            state.currentVThumbTop = state.maxVThumbTop;
        }
        const vThumb = vThumbRef.current;
        vThumb.style.transform = `translateY(${state.currentVThumbTop}px)`;
        const viewPort = viewPortRef.current;
        viewPort.scrollTop = utils_1.toFixed2(state.currentVThumbTop / state.vRatio);
    }), [state]);
    const stopDragVThumb = react_1.useCallback(() => {
        state.startVThumbTop = state.currentVThumbTop;
        state.ignoreScrollEvent = false;
        const vTrack = vTrackRef.current;
        vTrack.classList.remove("visible");
        document.removeEventListener("mouseup", stopDragVThumb);
        document.removeEventListener("mousemove", draggingVThumb);
    }, [state, draggingVThumb]);
    const startDragVThumb = react_1.useCallback((e) => {
        e.stopPropagation();
        e.preventDefault();
        state.startCursorY = e.y;
        state.ignoreScrollEvent = true;
        const vTrack = vTrackRef.current;
        vTrack.classList.add("visible");
        document.addEventListener("mouseup", stopDragVThumb);
        document.addEventListener("mousemove", draggingVThumb);
    }, [state, stopDragVThumb, draggingVThumb]);
    const draggingHThumb = react_1.useCallback(utils_1.rafThrottle((e) => {
        const cursorMoveDistance = e.x - state.startCursorX;
        state.currentHThumbLeft = state.startHThumbLeft + cursorMoveDistance;
        if (state.currentHThumbLeft < 0) {
            state.currentHThumbLeft = 0;
        }
        if (state.currentHThumbLeft > state.maxHThumbLeft) {
            state.currentHThumbLeft = state.maxHThumbLeft;
        }
        const hThumb = hThumbRef.current;
        hThumb.style.transform = `translateX(${state.currentHThumbLeft}px)`;
        const viewPort = viewPortRef.current;
        viewPort.scrollLeft = utils_1.toFixed2(state.currentHThumbLeft / state.hRatio);
    }), [state]);
    const stopDragHThumb = react_1.useCallback(() => {
        state.startHThumbLeft = state.currentHThumbLeft;
        state.ignoreScrollEvent = false;
        const hTrack = hTrackRef.current;
        hTrack.classList.remove("visible");
        document.removeEventListener("mouseup", stopDragHThumb);
        document.removeEventListener("mousemove", draggingHThumb);
    }, [state, draggingHThumb]);
    const startDragHThumb = react_1.useCallback((e) => {
        e.stopPropagation();
        e.preventDefault();
        state.startCursorX = e.x;
        state.ignoreScrollEvent = true;
        const hTrack = hTrackRef.current;
        hTrack.classList.add("visible");
        document.addEventListener("mouseup", stopDragHThumb);
        document.addEventListener("mousemove", draggingHThumb);
    }, [state, stopDragHThumb, draggingHThumb]);
    const moveThumb = react_1.useCallback(utils_1.rafThrottle(() => {
        const viewPort = viewPortRef.current;
        const vThumb = vThumbRef.current;
        const hThumb = hThumbRef.current;
        const scrollTop = viewPort.scrollTop;
        const scrollLeft = viewPort.scrollLeft;
        state.startVThumbTop = utils_1.toFixed2(scrollTop * state.vRatio);
        state.startHThumbLeft = utils_1.toFixed2(scrollLeft * state.hRatio);
        vThumb.style.transform = `translateY(${state.startVThumbTop}px)`;
        hThumb.style.transform = `translateX(${state.startHThumbLeft}px)`;
    }), [state]);
    const scroll = react_1.useCallback(() => {
        if (state.ignoreScrollEvent) {
            return;
        }
        moveThumb();
    }, [state, moveThumb]);
    react_1.useEffect(() => {
        const box = boxRef.current;
        const vThumb = vThumbRef.current;
        const hThumb = hThumbRef.current;
        const viewPort = viewPortRef.current;
        resize_observer_1.default.observe(box);
        box.onresize = reset;
        content_change_watcher_1.default.watch(viewPort, reset);
        vThumb.onmousedown = startDragVThumb;
        hThumb.onmousedown = startDragHThumb;
        viewPort.onscroll = scroll;
        return () => {
            resize_observer_1.default.unobserve(box);
            content_change_watcher_1.default.unwatch(viewPort);
            box.onresize = null;
            vThumb.onmousedown = null;
            hThumb.onmousedown = null;
            viewPort.onscroll = null;
        };
    }, [reset, startDragVThumb, startDragHThumb, scroll]);
    react_1.useEffect(reset);
    return (react_1.default.createElement("div", { ref: boxRef, className: `scroll-box ${(_a = props.className) !== null && _a !== void 0 ? _a : ""}`, style: props.style },
        react_1.default.createElement("div", { ref: viewPortRef, className: "scroll-box-view-port" }, props.children),
        react_1.default.createElement("div", { ref: vTrackRef, className: "scroll-box-track vertical" },
            react_1.default.createElement("div", { ref: vThumbRef, className: "scroll-box-thumb vertical" })),
        react_1.default.createElement("div", { ref: hTrackRef, className: "scroll-box-track horizontal" },
            react_1.default.createElement("div", { ref: hThumbRef, className: "scroll-box-thumb horizontal" }))));
}
exports.default = ScrollBox;
